import assert from '../assert';
export const DEFAULT_UNITS = 'px';
function setCssVar(cssVar, value) {
  document.documentElement.style.setProperty(cssVar, value);
}
function getCssVar(cssVar) {
  return getComputedStyle(document.documentElement).getPropertyValue(cssVar);
}
function setCssVarNumber(cssVar, value, units = DEFAULT_UNITS) {
  assert(typeof value === 'number', 'Value must be a number');
  setCssVar(cssVar, `${value}${units}`);
}
function getCssVarNumber(cssVar) {
  return parseInt(getCssVar(cssVar), 10);
}
export default {
  get: getCssVar,
  set: setCssVar,
  getNumber: getCssVarNumber,
  setNumber: setCssVarNumber
};